export const API_URL = 'https://know-india-dash-final.vercel.app/api'; 
// export const API_URL = 'http://localhost:3001/api'; 